import React from 'react'

export default function ArrowDown() {
  return <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M8.94559 0.180113C9.83649 0.180113 10.2827 1.25725 9.65269 1.88722L5.88679 5.65312C5.49627 6.04364 4.86311 6.04364 4.47258 5.65312L0.706681 1.88722C0.0767161 1.25725 0.522883 0.180113 1.41379 0.180113H8.94559Z" fill="#797979" />
	</svg>
}
